import React, { useEffect } from 'react'
import Script from 'next/script'
import Head from 'next/head'
import { useRouter } from 'next/router'
import Header2 from '@/partials/Header2'

const Support = () => {
  const router = useRouter()
  useEffect(() => {
    // Needed for cleaning residue left by the external script that can only be removed by reloading the page
    const onRouterChange = () => {
      var elements1 = document.getElementsByClassName(
        'fs_17c82cd4bcd2a15b5f746294b40b40647c1005006a433be6883a34225a03956c'
      )
      var elements2 = document.getElementsByClassName('fs-webform-loader')
      while (elements1.length > 0) {
        elements1[0].parentNode.removeChild(elements1[0])
      }
      while (elements2.length > 0) {
        elements2[0].parentNode.removeChild(elements2[0])
      }
    }
    router.events.on('routeChangeStart', onRouterChange)

    return () => {
      router.events.off('routeChangeStart', onRouterChange)
    }
  }, [router])

  useEffect(() => {
    if (router.pathname === '/support') {
      const script = document.getElementsByClassName(
        'fs_17c82cd4bcd2a15b5f746294b40b40647c1005006a433be6883a34225a03956c'
      )
      // if (script.length === 0) {
      //   router.reload()
      // }
      setTimeout(function () {
        if (script.length === 0) {
          router.reload()
        }
      }, 1000)
    }
  }, [router])
  return (
    <>
      <Head>
        <meta
          key="twitter:title"
          name="twitter:title"
          content="Tradly – Bring your Dream into Reality. API-FIRST COMMERCE."
        />
        <meta
          key="og:title"
          property="og:title"
          content="Tradly – Bring your Dream into Reality. API-FIRST COMMERCE."
        />
        <title>Tradly – Bring your Dream into Reality. API-FIRST COMMERCE.</title>
      </Head>{' '}
      {router.pathname === '/support' && (
        <Script
          type="text/javascript"
          strategy="afterInteractive"
          src="https://istrata.myfreshworks.com/crm/sales/web_forms/17c82cd4bcd2a15b5f746294b40b40647c1005006a433be6883a34225a03956c/form.js"
          crossorigin="anonymous"
          id="fs_17c82cd4bcd2a15b5f746294b40b40647c1005006a433be6883a34225a03956c"
        />
      )}
      <div className=" relative   pt-[20px] z-[-1] overflow-hidden"></div>
    </>
  )
}

export default Support
